import React from 'react';
import { componentService } from 'js/services/component.service';

export const Promotions = React.lazy(() => import(/* webpackChunkName: "promotions-list-page" */ './Promotions'));
export const PromotionPage = React.lazy(() => import(/* webpackChunkName: "promotion-page" */ './components/PromotionsPage/PromotionPage'));

// TODO after it gets reimplemented
// componentService.registerPageComponents({ 'bonus-multi-view': Promotions });
componentService.registerPageComponents({ 'promotion-page': PromotionPage });
